import {StyleOrder} from "../config-extractor/style.order";

export const buttonIndexSelector: Record<StyleOrder, string> = {
    buttons: ".r3z-ansbut-",
    answers: ".r3z-ans-"
};
